import { AuthRepositoryImpl } from '@infrastructure/repositories/AuthRepositoryImpl';
import { ProfileRepositoryImpl } from '@infrastructure/repositories/ProfileRepositoryImpl';
import { TwoFactorRepositoryImpl } from '@infrastructure/repositories/TwoFactorRepositoryImpl';
import { SessionRepositoryImpl } from '@infrastructure/repositories/SessionRepositoryImpl';
import { SettingsRepositoryImpl } from '@infrastructure/repositories/SettingsRepositoryImpl';
import { ThemeRepositoryImpl } from '@infrastructure/repositories/ThemeRepositoryImpl';
import { WorkspaceRepositoryImpl } from '@infrastructure/repositories/WorkspaceRepositoryImpl';
import { RoleRepositoryImpl } from '@infrastructure/repositories/RoleRepositoryImpl';
import { CollectionRepositoryImpl } from '@infrastructure/repositories/CollectionRepositoryImpl';
import { FolderRepositoryImpl } from '@infrastructure/repositories/FolderRepositoryImpl';
import { ApiRequestRepositoryImpl } from '@infrastructure/repositories/ApiRequestRepositoryImpl';
import { EnvironmentRepositoryImpl } from '@infrastructure/repositories/EnvironmentRepositoryImpl';
import { GlobalVariableRepositoryImpl } from '@infrastructure/repositories/GlobalVariableRepositoryImpl';
import { HistoryRepositoryImpl } from '@infrastructure/repositories/HistoryRepositoryImpl';
import { CookieRepositoryImpl } from '@infrastructure/repositories/CookieRepositoryImpl';
import { SearchRepositoryImpl } from '@infrastructure/repositories/SearchRepositoryImpl';
import { MockServerRepositoryImpl } from '@infrastructure/repositories/MockServerRepositoryImpl';
import { ActivityLogRepositoryImpl } from '@infrastructure/repositories/ActivityLogRepositoryImpl';
import { RequestExampleRepositoryImpl } from '@infrastructure/repositories/RequestExampleRepositoryImpl';
import { VariableHygieneRepositoryImpl } from '@infrastructure/repositories/VariableHygieneRepositoryImpl';
import { UploadRepositoryImpl } from '@infrastructure/repositories/UploadRepositoryImpl';
import { RequestSettingsRepositoryImpl } from '@infrastructure/repositories/RequestSettingsRepositoryImpl';
import { NotificationRepositoryImpl } from '@infrastructure/repositories/NotificationRepositoryImpl';
import { LoginUseCase } from '@core/use-cases/auth/LoginUseCase';
import { ChallengeTwoFactorUseCase } from '@core/use-cases/auth/ChallengeTwoFactorUseCase';
import { RegisterUseCase } from '@core/use-cases/auth/RegisterUseCase';
import { LogoutUseCase } from '@core/use-cases/auth/LogoutUseCase';
import { GetCurrentUserUseCase } from '@core/use-cases/auth/GetCurrentUserUseCase';
import { ForgotPasswordUseCase } from '@core/use-cases/auth/ForgotPasswordUseCase';
import { ResetPasswordUseCase } from '@core/use-cases/auth/ResetPasswordUseCase';
import { ResendVerificationEmailUseCase } from '@core/use-cases/auth/ResendVerificationEmailUseCase';

const authRepository = new AuthRepositoryImpl();

export const container = {
  auth: {
    login: new LoginUseCase(authRepository),
    challengeTwoFactor: new ChallengeTwoFactorUseCase(authRepository),
    register: new RegisterUseCase(authRepository),
    logout: new LogoutUseCase(authRepository),
    getCurrentUser: new GetCurrentUserUseCase(authRepository),
    forgotPassword: new ForgotPasswordUseCase(authRepository),
    resetPassword: new ResetPasswordUseCase(authRepository),
    resendVerificationEmail: new ResendVerificationEmailUseCase(authRepository),
  },
  profile: new ProfileRepositoryImpl(),
  twoFactor: new TwoFactorRepositoryImpl(),
  sessions: new SessionRepositoryImpl(),
  settings: new SettingsRepositoryImpl(),
  themes: new ThemeRepositoryImpl(),
  workspaces: new WorkspaceRepositoryImpl(),
  roles: new RoleRepositoryImpl(),
  collections: new CollectionRepositoryImpl(),
  folders: new FolderRepositoryImpl(),
  apiRequests: new ApiRequestRepositoryImpl(),
  environments: new EnvironmentRepositoryImpl(),
  globalVariables: new GlobalVariableRepositoryImpl(),
  history: new HistoryRepositoryImpl(),
  cookies: new CookieRepositoryImpl(),
  search: new SearchRepositoryImpl(),
  mockServers: new MockServerRepositoryImpl(),
  activityLogs: new ActivityLogRepositoryImpl(),
  requestExamples: new RequestExampleRepositoryImpl(),
  variableHygiene: new VariableHygieneRepositoryImpl(),
  uploads: new UploadRepositoryImpl(),
  requestSettings: new RequestSettingsRepositoryImpl(),
  notifications: new NotificationRepositoryImpl(),
} as const;
